import {spaceSizeFormat} from "@/utils/file";

function formatEchartsData(spaceSize) {
    const {
        containsLocation,
        effectiveLocation,
        fileCloudLocation,
        freeLocation,
        emailFileLocation
    } = spaceSize ?? {freeLocation: 0, fileCloudLocation: 0, effectiveLocation: 0};
    
    // 安全计算百分比，防止除以0或undefined导致NaN
    const calculatePercentage = (value, total) => {
        // 确保 value 和 total 都是有效数字
        const numValue = Number(value) || 0;
        const numTotal = Number(total) || 0;
        
        // 如果总数为0或无效，返回0
        if (numTotal === 0 || !isFinite(numTotal)) {
            return 0;
        }
        
        // 保留更高精度，避免极小占比在图表层被提前舍入成 0
        const percentage = (numValue / numTotal) * 100;
        return isFinite(percentage) ? Number(percentage.toFixed(6)) : 0;
    };
    
    let targetObjArray = [{
        name: "common_cloud_file_space_available",
        num: freeLocation || 0,
        numStr: spaceSizeFormat(freeLocation ?? 0),
        percentage: calculatePercentage(freeLocation, effectiveLocation)
    }, {
        name: "common_file_cloud",
        num: fileCloudLocation || 0,
        numStr: spaceSizeFormat(fileCloudLocation ?? 0),
        percentage: calculatePercentage(fileCloudLocation, effectiveLocation)
    },]
    return targetObjArray;
}

const echarts = require('echarts/lib/echarts');
require('echarts/lib/component/title');
require('echarts/lib/component/tooltip');
require('echarts/lib/component/legend');
require('echarts/lib/component/grid');
require('echarts/lib/chart/pie');


export {formatEchartsData, echarts}
